'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./LibraryPackHeader.scss');

var LibraryPackHeader = function (_React$Component) {
  (0, _inherits3.default)(LibraryPackHeader, _React$Component);

  function LibraryPackHeader() {
    (0, _classCallCheck3.default)(this, LibraryPackHeader);
    return (0, _possibleConstructorReturn3.default)(this, (LibraryPackHeader.__proto__ || (0, _getPrototypeOf2.default)(LibraryPackHeader)).apply(this, arguments));
  }

  (0, _createClass3.default)(LibraryPackHeader, [{
    key: 'render',
    value: function render() {
      var pack = this.props.pack;
      var id = pack.id,
          name = pack.name,
          priceMap = pack.priceMap,
          isIncomplete = pack.isIncomplete,
          presentation = pack.presentation;


      var src = presentation.coverImages && (0, _utils.getS3Url)(presentation.splashImage);

      return _react2.default.createElement(
        'section',
        { className: styles.LibraryPackHeader, style: { backgroundImage: 'url(' + src + ')' } },
        _react2.default.createElement('span', { className: styles.LibraryPackHeader__background }),
        _react2.default.createElement(
          'div',
          { className: styles.LibraryPackHeader__wrap },
          _react2.default.createElement(
            'div',
            { className: styles.LibraryPackHeader__guts },
            isIncomplete && _react2.default.createElement(
              'span',
              { className: styles.LibraryPackHeader__comingSoon },
              'Coming Soon'
            ),
            _react2.default.createElement(
              'h1',
              { className: styles.LibraryPackHeader__title },
              name
            ),
            _react2.default.createElement(
              'h2',
              { className: styles.LibraryPackHeader__description },
              presentation && presentation.subtitle
            )
          )
        )
      );
    }
  }]);
  return LibraryPackHeader;
}(_react2.default.Component);

exports.default = LibraryPackHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryPackHeader/LibraryPackHeader.jsx
// module id = 2355
// module chunks = 0